import { Navigate } from 'react-router-dom';
import { usePermissions, Permission } from '../../hooks/usePermissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
  permission?: Permission;
  permissions?: Permission[];
  requireAll?: boolean; // Si true, nécessite toutes les permissions, sinon au moins une
  fallbackPath?: string;
}

/**
 * Composant pour protéger les routes selon les permissions
 */
export default function ProtectedRoute({
  children,
  permission,
  permissions,
  requireAll = false,
  fallbackPath = '/'
}: ProtectedRouteProps) {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();

  // Vérifier la permission unique
  if (permission && !hasPermission(permission)) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Vérifier les permissions multiples
  if (permissions && permissions.length > 0) {
    const hasAccess = requireAll
      ? hasAllPermissions(...permissions)
      : hasAnyPermission(...permissions);

    if (!hasAccess) {
      return <Navigate to={fallbackPath} replace />;
    }
  }

  return <>{children}</>;
}
